import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    deleteDosage,
    getAllDosage,
    getDosageById,
    pagingDosage,
    saveDosage
} from 'app/services/DosageService';
import { Drug } from "app/common/Model/Drug";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

export default class DosageStore {
    listAllDosage = [];
    searchDosage = new SearchObject();
    pageDosage = null;
    selectedDosage = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllDosage = () => {
        if (this.listAllDosage?.length === 0 || this.recentlyUpdated) {
            getAllDosage()
                .then(({ data }) => {
                    this.listAllDosage = data;
                    this.recentlyUpdated = false;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                });
        }
    }

    pagingDosage = () => {
        pagingDosage(this.searchDosage)
            .then(({ data }) => {
                this.pageDosage = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchDosage) => {
        this.searchDosage = checkSearchObject(this.searchDosage, searchDosage);
        this.pagingDosage();
    }

    handleOpenFormCreateOrEdit = (dosageId) => {
        if (Boolean(dosageId)) {
            getDosageById(dosageId)
                .then(({ data }) => {
                    this.selectedDosage = data;
                    this.openFormCreateOrEdit = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedDosage = new Drug();
            this.openFormCreateOrEdit = true;
        }
    }

    saveDosage = async (dosage, { setSubmitting }) => {
        return await saveDosage(dosage)
            .then(() => {
                this.recentlyUpdated = true;
                this.selectedDosage = null;
                toast.success("Lưu liều dùng thành công!");
                this.handleClosePopup();
                this.pagingDosage();
            })
            .catch(error => {
                console.error(error);
                toast.error("Lưu thông tin liều dùng có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (dosage) => {
        this.selectedDosage = { id: dosage?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = () => deleteDosage(this?.selectedDosage?.id)
        .then(() => {
            if (this.searchDosage.pageIndex > 1 && this.pageDosage?.content?.length === 1) {
                this.searchDosage.pageIndex -= 1;
            }
            toast.success("Xóa liều dùng thành công!")
            this.handleClosePopup();
            this.recentlyUpdated = true;
            this.pagingDosage();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa liều dùng có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchDosage = new SearchObject();
        this.pageDosage = null;
        this.selectedDosage = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }



    //for choosing dosage popup in ChooseDosagePopup.jsx 
    listDosage = [];
    dosageIdSet = null;

    isValidDosage = dosage => {
        if (dosage && dosage?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addDosage = dosage => {
        if (!this.isValidDosage(dosage)) return;
        this.listDosage.push(dosage);
        this.dosageIdSet.add(dosage?.id);
    }

    initializeListDosage = dosages => {
        this.dosageIdSet = new Set();
        this.listDosage = [];
        if (dosages && dosages?.length > 0) {
            for (let i = 0; i < dosages.length; i++) {
                this.addDosage(dosages[i]);
            }
        }
    }

    removeDosage = dosage => {
        if (!this.isValidDosage(dosage)) return;
        if (this.dosageIdSet.has(dosage?.id)) {
            this.dosageIdSet.delete(dosage?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = dosage => {
        if (!this.isValidDosage(dosage)) return;
        return this.dosageIdSet.has(dosage?.id);
    }

    getDosageIdSet = () => {
        return this.dosageIdSet;
    }

    getListDosage = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listDosage && this.listDosage?.length > 0) {
            for (let i = 0; i < this.listDosage.length; i++) {
                const dosage = this.listDosage[i];
                if (this.isExist(dosage) && !bufferIdSet.has(dosage?.id)) {
                    data.push(dosage);
                    bufferIdSet.add(dosage?.id);
                }
            }
        }
        this.listDosage = data;
        return data;
    }
    //end
}